import dayjs from 'dayjs';
import React, { useState } from 'react';
import { DatePicker, Dialog, Form, MessagePlugin } from 'tdesign-react';
import { resetCursors } from '@/services/utilService';
import FormInfoBlock from '@/components/FormInfoBlock';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { deal70101 } from '@/utils/common';

const { FormItem } = Form;

export default function Offset({ handleClose, visible, detail = {}, onRefresh, ...others }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  const descriptions = [
    {
      label: '集群名称：',
      value: detail.clusterName,
    },
    {
      label: 'Topic：',
      value: detail.topic,
    },
    {
      label: '订阅名：',
      value: detail.subscription,
    },
  ];

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const params = {
          clusterName: detail.clusterName,
          topic: detail.topic,
          subscription: detail.subscription,
          timestamp: dayjs(fields.timestamp).valueOf(),
        };
        const { meta } = await resetCursors(params);
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/utils/message',
            subscription: detail.subscription,
          });
          return;
        }
        MessagePlugin.success('操作成功！');
        handleClose();
        onRefresh();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header='重置偏移量'
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      onCancel={handleClose}
      onCloseBtnClick={handleClose}
      width={550}
      visible={visible}
      {...others}
    >
      <Form form={form} onSubmit={handleSubmit}>
        <FormItem name='timestamp' label='时间' rules={[{ required: true }]}>
          <DatePicker
            enableTimePicker
            style={{ width: '70%' }}
            placeholder='请选择'
            clearable
            presets={{ 此刻: dayjs().format('YYYY-MM-DD HH:mm:ss') }}
          />
        </FormItem>
      </Form>
      <FormInfoBlock items={descriptions} />
    </Dialog>
  );
}
